import { Spin } from "antd";
import React, { FC } from "react";

interface LoadingComponentProps {}

const LoadingComponent: FC<LoadingComponentProps> = () => {
  const contentStyle: React.CSSProperties = {
    padding: 50,
    background: "rgba(0, 0, 0, 0.05)",
    borderRadius: 4,
  };

  const content = <div style={contentStyle} />;
  return (
    <div className="min-h-screen min-w-full w-full h-full flex justify-center items-center">
      <Spin tip="Đang tải" size="large">
        {content}
      </Spin>
    </div>
  );
};

export default LoadingComponent;
